export default __webpack_public_path__ + "static/media/Slide13.b3dea7a3.jpg";